import React from 'react'
import Welcome from '../../components/Welcome'

const PageWelcome = () => {
  return <Welcome />
}

export default PageWelcome
